import { I18n } from '@calendly/i18n'
import { IconButton } from '@calendly/ui/components/icon-button'
import { ArrowChevronLeftIcon, CloseIcon } from '@calendly/ui/components/icons'
import { TitleText } from '@calendly/ui/components/typography'
import PropTypes from 'prop-types'
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { mobileStepSelector } from '../selectors'
import { MOBILE_STEPS, previousMobileStep, setMobileStep } from '../slice'
import {
  MobileShellContent,
  NavigatorItems,
  NavigatorLeading,
  NavigatorTitle,
  NavigatorWrapper,
} from './mobile_shell_styles'

export const MobileShell = ({ onClose, children }) => {
  const dispatch = useDispatch()
  const mobileStep = useSelector(mobileStepSelector)

  const handleBack = useCallback(() => {
    if (mobileStep === MOBILE_STEPS.date) {
      onClose()
      return
    }

    const prior = previousMobileStep(mobileStep)
    if (prior) {
      dispatch(setMobileStep(prior))
    }
  }, [dispatch, mobileStep, onClose])

  return (
    <>
      <NavigatorWrapper data-testid="book-modal-mobile-header">
        <NavigatorItems>
          <NavigatorLeading>
            <IconButton
              size="medium"
              title={I18n.t('publisher.action.back')}
              onClick={handleBack}
              data-testid="book-modal-mobile-back"
            >
              <ArrowChevronLeftIcon />
            </IconButton>
            <NavigatorTitle>
              <TitleText level={2} as="h1" size="small">
                {I18n.t('publisher.contacts.buttons.book_meeting')}
              </TitleText>
            </NavigatorTitle>
          </NavigatorLeading>
          <IconButton
            size="medium"
            title={I18n.t('publisher.action.close')}
            onClick={onClose}
            data-testid="book-modal-mobile-close"
          >
            <CloseIcon />
          </IconButton>
        </NavigatorItems>
      </NavigatorWrapper>
      <MobileShellContent data-testid="book-modal-mobile-shell">
        {children}
      </MobileShellContent>
    </>
  )
}

MobileShell.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
}
